/**
 * Single source of truth for product/brand strings on the web app.
 *
 * Reads `VITE_APP_NAME` from the build-time env so a deployment can
 * relabel without touching code. The default ('Bacsys Atom') matches
 * the full mobile app's brand so all three surfaces are aligned by
 * default; override in `.env.production` for a different deployment.
 */
export const APP_NAME = (import.meta.env.VITE_APP_NAME as string | undefined)
  ?.trim() || 'Bacsys Optimo'

/** Path to the brand mark (served from `public/`). Native colours
 *  — grey letters + orange dot on transparent background. */
export const APP_LOGO = '/sila-logo.webp'

/** Dark-mode variant with white letters and the orange dot preserved.
 *  When missing on disk the file 404s and the layouts fall back to
 *  filtering `APP_LOGO` to pure white — same fallback the AuthShell
 *  currently uses for the dark hero. Drop `sila-logo-dark.webp` in
 *  `public/` to activate. */
export const APP_LOGO_DARK = '/sila-logo-dark.webp'
